import { IconButton } from '@fluentui/react';
import styled from 'styled-components';

export const YearSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 1rem;
`;

export const YearSelectorTitle = styled.h1`
  font-weight: 600;
  font-size: 1.25rem;
  cursor: default;
`;

export const YearSelectorButtons = styled(IconButton)`
  color: ${(props) => props.theme.calendarDateColor};
  &:hover {
    color: ${(props) => props.theme.calendarDateColorHover};
  }
  &:active {
    color: ${(props) => props.theme.calendarDateColorHover};
  }
  &:disabled {
    background-color: transparent;
  }
`;
